import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { type ChildRouteContext } from "@/root";

import LoginPic from "../assets/login-page.png";
import LoginForm from "../components/login/LoginForm";
import { fetchMeQueryOptions } from "../services";
import { checkOauthCallback } from "../services/oauth";

export const Route = createFileRoute("/login")({
  validateSearch: z.object({
    redirect: z.string().optional(),
    oauth_success: z.number({ coerce: true }).optional(),
    error: z.string().optional(),
  }),
  beforeLoad: async ({ context, search }) => {
    if (checkOauthCallback(search.oauth_success ? true : false, search.error)) {
      // If oauth callback is handled, we don't need to proceed further
      return {
        title: () => context.t("Login", { ns: "core.user" }),
      } satisfies ChildRouteContext;
    }

    let user = null;
    try {
      user = await context.queryClient.ensureQueryData(fetchMeQueryOptions());
    } catch (error) {
      //
    }

    if (user) {
      throw redirect({
        to: search.redirect || "/",
      });
    }

    return {
      title: () => context.t("Login", { ns: "core.user" }),
    } satisfies ChildRouteContext;
  },
  component: Component,
});

function Component() {
  return (
    <div className="flex h-screen justify-between">
      <div className="flex min-w-0 flex-1">
        <LoginForm />
        <div className="hidden min-w-0 flex-1 sm:flex">
          <div
            className="h-full w-full bg-cover bg-center"
            style={{
              backgroundImage: `url(${LoginPic})`,
            }}
          />
        </div>
      </div>
    </div>
  );
}
